import { CLOSE_NOTIFICATION, NEW_NOTIFICATION, REMOVE_NOTIFICATION } from '../actions/types/NotificationTypes';
import guid from '../../tools/GUIDTools';

const initialState = {
  byAggregateId: {},
  allAggregateIds: [],
};

const defaultNotificationValues = {
  isClosing: false,
};

export default (state = initialState, action) => {
  let notification;
  let notificationId;
  let notificationExists;
  let newState;

  switch (action.type) {
  case NEW_NOTIFICATION:
    notificationId = guid();
    notification = {};
    notification[notificationId] = {
      id: notificationId,
      ...defaultNotificationValues,
      ...action.payload,
    };

    return {
      ...state,
      byAggregateId: {
        ...state.byAggregateId, ...notification,
      },
      allAggregateIds: [...state.allAggregateIds, notificationId],
    };

  case CLOSE_NOTIFICATION:
    notification = {};
    notification[action.payload.id] = {
      ...state.byAggregateId[action.payload.id],
      ...action.payload,
    };

    return { ...state, byAggregateId: { ...state.byAggregateId, ...notification } };

  case REMOVE_NOTIFICATION:
    notification = action.payload;
    notificationExists = (state.allAggregateIds.indexOf(notification.id) !== -1);

    if (notificationExists) {
      const byAggregateId = Object.keys(state.byAggregateId)
        .filter((key) => key !== notification.id)
        .reduce((obj, key) => {
          const newObj = obj;
          newObj[key] = state.byAggregateId[key];
          return newObj;
        }, {});
      const allAggregateIds = state.allAggregateIds.filter((id) => id !== notification.id);

      newState = {
        ...state,
        byAggregateId,
        allAggregateIds,
      };
    } else {
      newState = state;
    }

    return newState;
  default:
    return state;
  }
};
